'use strict'

import { device as deviceHandler } from '@/handler'
import storage from '@/libs/storage'

const get = async (_this) => {
  log('deviceController.get()')
  const setDevices = _this.$store._mutations.setDevices[0]
  const setDevice = _this.$store._mutations.setDevice[0]
  const devices = await deviceHandler.get()
  log(devices)
  if (_.size(devices) > 0) {
    storage.local.setItem('devices', JSON.stringify(devices))
    setDevices(devices)
  }
  const type = storage.session.getItem('device')
  let device = _.find(devices, { type })
  if (!device) {
    let myDevices = storage.local.getItem('my_devices')
    if (myDevices) {
      myDevices = JSON.parse(myDevices)
      device = myDevices[0]
    } else {
      device = _.find(devices, { type: 'ifline' })
    }
    storage.session.setItem('device', device.type)
  }
  setDevice(device || devices[0])
}

export default {
  get
}
